import { render } from "./Navigation.vue?vue&type=template&id=6d3f21a7&setup=true"
const script = {}

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__